import React from 'react';
import { Box, Typography, AppBar, Toolbar } from '@mui/material';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';

const Header = () => {
  return (
    <AppBar position="static" color="primary" elevation={0}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <RecordVoiceOverIcon sx={{ mr: 2, fontSize: 40, color: '#ffffff' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Echo AI Assistant
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
